module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "img5a"
  }, [_c('img', {
    attrs: {
      "alt": "art",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction"
    }
  }, [_c('em', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/acknowledgments"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter001"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 1")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v("Chikagou")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter002"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 2")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v("Albert Spalding")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter003"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 3")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v("Spalding’s Revolution")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter004"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 4")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Great Anson")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter005"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 5")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v("Mike Kelly")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter006"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 6")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v("Spalding’s Dynasty")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter007"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 7")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v("World Series Failure")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 8")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v("Stars for Sale")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 9")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Players Revolt")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 10")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Anson’s Demise")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 11")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Al Spalding: Savior")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 12")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Selee’s Genius")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 13")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Cubs Grow Claws")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 14")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Peerless Leader")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 15")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("116–36")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 16")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("A Fine Bunch of Stiffs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 17")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("World Champs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 18")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Warren Gill Affair")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 19")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("September 23, 1908")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter020",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 20")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("A Tie")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter021",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 21")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Four to Two")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter022",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 22")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Champs Again")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter023",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 23")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Continued Success")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter024",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 24")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Murphy’s Law")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter025",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 25")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Charles Weeghman")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter026",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 26")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Hippo Loses a No-Hitter")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter027",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 27")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Transitions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter028",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 28")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Tales from the Visiting Clubhouse")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter029",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 29")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Alex")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter030",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 30")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Marse Joe Arrives")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter031",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 31")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Mr. Wrigley")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter032",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 32")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("A Powerhouse")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter033",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 33")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("When Eight Runs Weren’t Enough")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter034",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 34")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("One Firing Too Many")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter035",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 35")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Death of William Wrigley")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter036",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 36")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Scandal—and Victory")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter037",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 37")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Mythical Called Shot")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter038",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 38")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Death of William Veeck")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter039",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 39")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Philibuck")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter040",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 40")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Twenty-one in a Row")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter041",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 41")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Stan Hack Stands on Third")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter042",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 42")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Home Run in the Gloaming")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter043",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 43")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Diz’s Last Stand")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter044",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 44")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Crazy World of PK Wrigley")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter045",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 45")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Wartime Ball")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter046",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 46")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Workhorse")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter047",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 47")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Jolly Cholly")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter048",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 48")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Roomies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter049",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 49")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The War Pennant")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter050",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 50")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Depths")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter051",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 51")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Minor Leagues")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter052",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 52")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Boyhood Memories")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter053",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 53")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Mr. Cub")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter054",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 54")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Professor")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter055",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 55")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Kid from Garlic Gulch")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter056",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 56")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The College of Coaches")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter057",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 57")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Cornerstone")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter058",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 58")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Kenny Hubbs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter059",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 59")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Leo")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter060",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 60")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Fergie")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter061",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 61")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Flying High in ’69")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter062",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 62")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Freefall")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter063",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 63")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Leo’s Demise")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter064",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 64")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Mad Dog and Bruce")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter065",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 65")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Death of the Reserve Clause and PK Wrigley")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter066",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 66")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Big $$$, Low Morale")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter067",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 67")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Harry")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter068",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 68")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Dallas Green Takes Over")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter069",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 69")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Red Baron")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter070",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 70")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("So Close")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter071",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 71")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Demise of Dallas")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter072",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 72")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Let There Be Lights")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter073",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 73")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Departures")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter074",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 74")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Semper Harry")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter075",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 75")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("MacPhail Shakes Things Up")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter076",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 76")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Sad Goodbyes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter077",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 77")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("K as in Kerry")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter078",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 78")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Sammy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter079",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 79")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Curse of Greg Maddux")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/appendix001",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 75
// module chunks = 0